import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { Patient, Profile } from '../models/index';
import { Location } from '@angular/common';
import { Api, ErrorHelper, Session, Ui } from '../services/index';

@Component({
    selector: 'signup-check-email',
    templateUrl: 'signup-check-email.html'
})
export class SignupCheckEmail {
  emailAddress: string;
  emailFormGroup: FormGroup;
  submitted: boolean;
  pathString: string; //**
  userId:number;
      
  constructor(private api: Api, 
              private errorHelper: ErrorHelper,
              private fb: FormBuilder,
              private router: Router,
              private service: NotificationsService,
              private session: Session,
              private ui: Ui,
              private location: Location,  
                ) {
                
          this.pathString = location.path();
    this.emailFormGroup = this.fb.group({
      'email': new FormControl(this.emailAddress, [this.emailOrEmpty, Validators.required])
    })
  }
  
  ngOnInit() {
    if (this.pathString.lastIndexOf('user=') >= 0) {
      let user = JSON.parse( decodeURIComponent( this.pathString.substring(this.pathString.lastIndexOf('user=') + 5) )); 
      console.log('user object:',user);
      this.emailAddress  = user.email;
      this.userId = user.Id;
    }
  }

  emailOrEmpty(control: AbstractControl): ValidationErrors {
    if (!control.value) {
      return null;
    }
  
    return Validators.email(control);
  }

  get email() { return this.emailFormGroup.get('email'); }

  continue() { 
    this.requesting(true);

    console.log('signup-check-email.ts this.emailAddress:', this.emailAddress);

    this.api.getRegistrationStatus(this.emailAddress)
      .subscribe(result => {
        if(!result.isActivated) {
          this.session.patient = new Patient();
          this.session.patient.email = this.emailAddress;
          this.session.patient.userId = this.userId;
          this.router.navigate(['/signup-patient' ]);
        } else {
          this.service.error('This email address is already in use. Please try logging in.');
        }
        this.requesting(false);
      }, ex => {
        this.errorHelper.handleServerValidation(this.emailFormGroup, ex);
        this.requesting(false);
      });
  }

  requesting(requesting: boolean){
      this.ui.showLoadingIndicator(requesting);
      this.submitted = requesting;
  }

  termsTapped() {
    let caredocurl = "http://memd.force.com/agreement/agreements?name=useagreement";
    let newWindow = window.open("about:blank", "_blank");
    newWindow.opener = null;
    newWindow.location.href = caredocurl;
  }

  privacyTapped() {
    let caredocurl = "http://memd.force.com/agreement/agreements?name=privacy";
    let newWindow = window.open("about:blank", "_blank");
    newWindow.opener = null;
    newWindow.location.href = caredocurl;   
  }

 
}